export const childsAjustes = [
  {
    path: "usuarios",
    name: "admin-ajustesEmpresa-usuarios",
    component: () =>
      import(
        /* webpackChunkName: "ajustesEmpresa-usuarios" */ "@/modules/admin/pages/ajustesEmpresa/Usuarios.vue"
      ),
  },
  {
    path: "audios",
    name: "admin-ajustesEmpresa-audios",
    component: () =>
      import(
        /* webpackChunkName: "ajustesEmpresa-audios" */ "@/modules/admin/pages/ajustesEmpresa/Audios.vue"
      ),
  },
  {
    path: "colaLlamadas",
    name: "admin-ajustesEmpresa-colaLlamadas",
    component: () =>
      import(
        /* webpackChunkName: "ajustesEmpresa-colaLlamadas" */ "@/modules/admin/pages/ajustesEmpresa/ColaLlamadas.vue"
      ),
  },
  {
    path: "did",
    name: "admin-ajustesEmpresa-did",
    component: () =>
      import(
        /* webpackChunkName: "ajustesEmpresa-did" */ "@/modules/admin/pages/ajustesEmpresa/DID.vue"
      ),
  },
  {
    path: "extensiones",
    name: "admin-ajustesEmpresa-extensiones",
    component: () =>
      import(
        /* webpackChunkName: "ajustesEmpresa-extensiones" */ "@/modules/admin/pages/ajustesEmpresa/Extensiones.vue"
      ),
  },
  {
    path: "franjasHorarias",
    name: "admin-ajustesEmpresa-franjasHorarias",
    component: () =>
      import(
        /* webpackChunkName: "ajustesEmpresa-franjasHorarias" */ "@/modules/admin/pages/ajustesEmpresa/FranjasHorarias.vue"
      ),
  },
  {
    path: "gruposDeTimbrado",
    name: "admin-ajustesEmpresa-gruposDeTimbrado",
    component: () =>
      import(
        /* webpackChunkName: "ajustesEmpresa-gruposDeTimbrado" */ "@/modules/admin/pages/ajustesEmpresa/GruposTimbrado.vue"
      ),
  },
  {
    path: "ivr",
    name: "admin-ajustesEmpresa-ivr",
    component: () =>
      import(
        /* webpackChunkName: "ajustesEmpresa-ivr" */ "@/modules/admin/pages/ajustesEmpresa/IVR.vue"
      ),
  },
  {
    path: "labels",
    name: "admin-ajustesEmpresa-labels",
    component: () =>
      import(
        /* webpackChunkName: "ajustesEmpresa-labels" */ "@/modules/admin/pages/ajustesEmpresa/Labels.vue"
      ),
  },
  {
    path: "eventTypes",
    name: "admin-ajustesEmpresa-eventTypes",
    component: () =>
      import(
        /* webpackChunkName: "ajustesEmpresa-eventTypes" */ "@/modules/admin/pages/ajustesEmpresa/EventType.vue"
      ),
  },
  // {
  //   path: "widgets",
  //   name: "admin-ajustesEmpresa-widgets",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "ajustesEmpresa-widgets" */ "@/modules/admin/pages/ajustesEmpresa/Widgets.vue"
  //     ),
  // },
];
